/**
 * Created by luka on 27.02.2018.
 */

export const colors = {
	primaryColor: '#028AED',
	primaryColor_light: '#CCEAFF',
	primaryColor_dark: '#4F50CC',
	secondaryColor: '#11EDAC',
	secondaryColor_light: '#54FEBD',
	white: '#FFFFFF',
	dirty_white: '#F9F9FA',
	back: '#000000',
	red: '#CA0519',
	green: '#1ED15E',
	grey: '#08242A',
	grey_light: '#2A313A',
	text: '#08242A',
	text_mid: '#6F7074',
	text_light: '#B0B3B4',
	separator: '#EBEBEB',
	transparent: '#00000000',

	primaryLight: '#029EE9',
	primarySuperLight: '#CCEAFF',
};



// WEBPACK FOOTER //
// ./src/styles/colors.js